import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Unmasking Invitation
  [types.GET_UNMASKING_INVITATION_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_UNMASKING_INVITATION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_UNMASKING_INVITATION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};